import React from "react";
import { HeaderCaption, Space, Title, Subtitle, Main, CardSection, Container, CardTitle, CardFooter, CardHeader } from "./CardStyles";
import Notice from '../../OnBoard/Notice';
import smiOne_logo from '../../../assets/smi-kudzu-images/smi_kudzu_logo.png'
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';

const Card = (props) => {
  const { CardRadius, isForMobile, isLogo, HeaderRadius, cardBg, footerClass, isHeaderCaption, heading, isHome, subheading, isActive, CardSectionRadius, Cardcaption, Cardsubcaption, children, header, HeaderContent, footer, cardHeight, footerContent, cardWidth, HeaderRightRadius, isPerk, isProfile, isWhite, backgroundColor, isShowNotice, isDark, isDarkForKudzu, isWhiteForSignup, isCustomBar, showBackButton, onBackClick, backButtonText } = props
  const isFromSmiOne = useSelector((state) => state.fromSmiOne);
  const { t } = useTranslation();

  return (
    <> <div className="sm:block hidden">
      {/* Back Button - Only shows when showBackButton is true */}
      {showBackButton && onBackClick && (
        <div className="w-full mb-4">
          <button
            type="button"
            className="font-hanken-grotesk text-[var(--text-clr-secondary)] lg:text-[20px] md:text-[20px] sm:text-[12px] text-[18px] leading-[30px]
              cursor-pointer flex items-center hover:opacity-80 transition-opacity"
            onClick={onBackClick}
          >
            <svg 
              className="w-4 h-4 mr-2" 
              fill="none" 
              stroke="var(--text-clr-secondary)" 
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            {backButtonText || t('back')}
          </button>
        </div>
      )}

     
        <HeaderCaption isHeaderCaption={isHeaderCaption}>
          <Title isprimary>
            {heading}
            <Subtitle>{subheading}</Subtitle>
          </Title>
        </HeaderCaption>
      </div>
      {
        !isLogo ? <Space></Space> : ""
      }
      

      <Main isHome={isHome}>
        <CardSection style={{ height: cardHeight != null ? cardHeight : '800px', backgroundColor: cardBg ? "#324261" : "" }}
          CardRadius={CardRadius} isPerk={isPerk} isProfile={isProfile}
          isWhite={isWhite} isDark={isDark} isDarkForKudzu={isDarkForKudzu}
          isWhiteForSignup={isWhiteForSignup} isCustomBar={isCustomBar}
          >
          <CardHeader ishidden={header} backgroundColor={backgroundColor} HeaderRadius={HeaderRadius} isActive={isActive}  >
            {HeaderContent}
          </CardHeader>
          <Container style={{ width: cardWidth }}>

            <div className="flex justify-start sm:justify-center sm:hidden">
              <HeaderCaption isHeaderCaption={isHeaderCaption}>
                <Title isprimary>
                  {heading}
                  <Subtitle>{subheading}</Subtitle>
                </Title>
              </HeaderCaption>
            </div>

            <div className={`  ${isForMobile ? '' :''}`}>
              <CardTitle as={header ? "h2" : "div"} isPrimary>
                {
                  (isLogo != undefined && isLogo) &&  <img src={ isFromSmiOne ? smiOne_logo : ""}
                  className={` ${  isFromSmiOne ? ' h-[55.43px]  md:mb-[47px]' : ''}  mb-[35px] md:mb-[51px]`} alt="Modal Logo" />
                }
                 
                {Cardcaption}
              </CardTitle>
            </div>
            {children}
          </Container>
          <CardFooter className={footerClass ? "mb-10" : ""} ishidden={footer} {...(props?.footerBgDisabled ? {} : { backgroundColor: backgroundColor })}>
            {footerContent}
          </CardFooter>
        </CardSection>
        <div className="sm:hidden">
          {(isShowNotice !== undefined && isShowNotice == true) && <Notice />}
        </div>
      </Main>
    </>
  );
};

export default Card;
